import { ICONS_WEB, NAV_ITEM_GROUPS } from "@miplatform/constants";
import { INavItemConfig } from "@miplatform/types";

export const homesNavItems: INavItemConfig[] = [
  {
    name: "Homes",
    icon: ICONS_WEB.HOME_GROUP,
    path: "/homes",
    testId: "nav-item-homes",
    group: NAV_ITEM_GROUPS.GENERAL,
  },
];
